module.exports = __webpack_public_path__ + "media/icons/magnifing-glass-39cfcac2.svg";